import { Wifi, Phone, Tv, Camera, Building2 } from 'lucide-react';
import { Service } from '../types';

export const services: Service[] = [
  {
    icon: <Wifi className="h-12 w-12" />,
    title: "Internet",
    description: "Experimentează viteza și stabilitatea internetului de ultimă generație prin fibră optică!",
    features: [
      "Viteză garantată prin fibră optică direct în casă (FTTH)",
      "Latență ultra-scăzută pentru gaming și streaming 4K",
      "Router Wi-Fi performant inclus în toate pachetele",
      "Suport tehnic dedicat 24/7",
      "Trafic nelimitat fără restricții"
    ],
    packages: [
      {
        name: "Start",
        price: "150",
        features: [
          "Viteză până la 200 Mbps",
          "Instalare Gratuită",
          "Router Wi-Fi inclus",
          "IP Static"
        ]
      },
      {
        name: "Premium",
        price: "200",
        popular: true,
        features: [
          "Viteză până la 300 Mbps",
          "Instalare Gratuită",
          "Router Wi-Fi inclus",
          "IP Static"
        ]
      },
      {
        name: "Pro",
        price: "250",
        features: [
          "Viteză până la 500 Mbps",
          "Instalare Gratuită",
          "Router Wi-Fi inclus",
          "IP Static"
        ]
      }
    ]
  },
  {
    icon: <Building2 className="h-12 w-12" />,
    title: "Intercom",
    description: "Sisteme moderne de interfon pentru blocuri și complexe rezidențiale",
    features: [
      "Sisteme video HD cu unghi larg de vizualizare și vedere nocturnă",
      "Control prin smartphone cu notificări instant",
      "Cartele și tag-uri moderne cu criptare avansată",
      "Integrare cu sisteme de securitate existente",
      "Instalare profesională cu garanție extinsă",
      "Mentenanță periodică inclusă în preț"
    ],
    packages: [
      {
        name: "Acces",
        price: "12",
        features: [
          "Fără Interfon",
          "Un Acces Card/Tag inclus",
          "Acces Card/Tag adăugator x 40 lei/buc"
        ]
      },
      {
        name: "Full",
        price: "36",
        features: [
          "Interfon Audio/Video",
          "Un Acces Card/Tag inclus",
          "Aplicație Mobilă",
          "Acces Card/Tag adăugator x 40 lei/buc"
        ]
      }
    ]
  },
  {
    icon: <Phone className="h-12 w-12" />,
    title: "Telefonie",
    description: "Servicii de telefonie fixă și IP pentru comunicare eficientă",
    features: [
      "Calitate HD a sunetului pentru convorbiri clare",
      "Tarife preferențiale pentru apeluri internaționale",
      "Funcții avansate: robot telefonic, conferințe, redirecționare",
      "Păstrează-ți numărul vechi sau primește unul nou",
      "Soluții personalizate pentru business cu numere multiple",
      "Integrare cu sisteme CRM și centrale virtuale"
    ],
    packages: [
      {
        name: "Înlesniri",
        price: "12",
        features: [
          "300 Minute Locale incluse",
          "Local extra - 0.14 lei/min",
          "National - 0.30 lei/min",
          "Mobil - 1.44 lei/min",
          "Instalare Gratuită"
        ]
      },
      {
        name: "Standart",
        price: "12/24",
        features: [
          "0/300 Minute locale incluse",
          "Local extra - 0.14 lei/min",
          "National - 0.30 lei/min",
          "Mobil - 1.44 lei/min",
          "Număr Fix Dedicat/Portat"
        ]
      }
    ]
  },
  {
    icon: <Tv className="h-12 w-12" />,
    title: "Televiziune",
    description: "Canale TV HD și conținut premium pentru toată familia",
    features: [
      "Peste 200 canale, inclusiv 60+ în calitate HD și 4K",
      "Canale premium de filme, sport și documentare",
      "Funcții avansate: Time Shift, Video on Demand",
      "Arhivă TV pe 7 zile pentru programele favorite",
      "Aplicație mobilă pentru vizionare pe orice dispozitiv",
      "Ghid electronic de programe și control parental"
    ],
    packages: [
      {
        name: "FULL",
        price: "60",
        features: [
          "190+ Canale TV",
          "Până la 5 televizoare",
          "EPG inclus"
        ]
      },
      {
        name: "Plus BOX",
        price: "20",
        features: [
          "IPTV Box Android",
          "App YouTube"
        ]
      }
    ]
  },
  {
    icon: <Camera className="h-12 w-12" />,
    title: "Supraveghere Video",
    description: "Sisteme de supraveghere video pentru siguranța ta",
    features: [
      "Camere 4K cu vedere nocturnă și unghi larg",
      "Tehnologie AI pentru detecție și recunoaștere",
      "Stocare redundantă în cloud cu backup automat",
      "Monitorizare în timp real pe telefon sau tabletă",
      "Notificări instant pentru evenimente importante",
      "Instalare profesională și configurare incluse"
    ],
    packages: [
      {
        name: "CAM 5 zile",
        price: "75",
        features: [
          "Camere Full HD",
          "Stocare 5 zile",
          "Vizualizare Online"
        ]
      },
      {
        name: "CAM 10 zile",
        price: "90",
        features: [
          "Camere Full HD",
          "Stocare 10 zile",
          "Vizualizare Online"
        ]
      },
      {
        name: "CAM 30 zile",
        price: "150",
        features: [
          "Camere Full HD",
          "Stocare 30 zile",
          "Vizualizare Online"
        ]
      }
    ]
  }
];